(() => {
  'use strict';
  function init(page){
  if(!page||page.dataset.collectionReady)return;page.dataset.collectionReady='true';
  const buttons=[...page.querySelectorAll('[data-view]')];
  const grid=page.querySelector('[data-product-grid]');
  let generation=0;
  function setView(view){
    if(!['hair','look'].includes(view))return;
    const ticket=++generation;
    buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.view===view)));
    const status=page.querySelector('[data-view-status]');
    status.textContent=view==='hair'?page.dataset.statusHair:page.dataset.statusLook;
    for(const img of page.querySelectorAll('.bc-main-image')){
      const src=view==='look'?img.dataset.lookSrc:img.dataset.hairSrc;
      const alt=view==='look'?img.dataset.lookAlt:img.dataset.hairAlt;
      const preload=new Image();
      preload.onload=()=>{if(ticket!==generation)return;img.removeAttribute('srcset');img.src=src;img.alt=alt;img.closest('.bc-card-image').classList.toggle('is-look',view==='look');};
      preload.onerror=()=>{if(ticket!==generation)return;status.textContent=page.dataset.statusError;};
      preload.src=src;
    }
  }
  buttons.forEach(b=>b.addEventListener('click',()=>setView(b.dataset.view)));
  const sort=page.querySelector('[data-sort]');
  const currentSort=new URL(window.location.href).searchParams.get('sort_by');
  sort.value=currentSort==='price-ascending'?'price-asc':currentSort==='price-descending'?'price-desc':'featured';
  sort.addEventListener('change',event=>{
    const url=new URL(window.location.href);
    url.searchParams.set('sort_by',event.target.value==='price-asc'?'price-ascending':event.target.value==='price-desc'?'price-descending':'manual');
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });
  }
  document.querySelectorAll('.bc-collection').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.bc-collection').forEach(init));
})();
